<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="添加外协厂家">
      </el-page-header>
      <form class="form-horizontal" @submit.prevent="handleFactoryNew">
        <div class="panel-body">
          <div class="row">
            <div class="col-lg-6 pad-top">
              <div class="form-group col-sm-12">
                <label class="col-md-3 control-label">名称</label>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ error: $v.factory.name.$error }"
                    v-model="factory.name"
                  />
                </div>
              </div>
              <div class="form-group col-sm-12">
                <label class="col-md-3 control-label">邮箱</label>
                <div class="col-md-9">
                  <input type="" class="form-control" v-model="factory.email" />
                </div>
              </div>
              <div class="form-group col-sm-12">
                <label class="col-md-3 control-label">联系人</label>
                <div class="col-md-9">
                  <input
                    type=""
                    class="form-control"
                    v-model="factory.contact_person"
                  />
                </div>
              </div>
              <div class="form-group col-sm-12">
                <label class="col-md-3 control-label">联系电话</label>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="factory.contact_phone"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="col-md-8 col-md-offset-4">
                <button class="btn btn-success btn-labeled">保存</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { factoryNew } from '@/service/getData'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  validations: {
    factory: {
      name: {
        required,
        maxLength: maxLength(30),
      },
    },
  },
  data() {
    return {
      factory: {},
    }
  },
  methods: {
    async handleFactoryNew() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      let res = await factoryNew(this.factory)
      if (res.status != 0) return
      this.$router.push('/factories')
    },
  },
}
</script>